// Reunderwriting Module (Tier 3) PR 4 — left-rail filters for the
// reunderwriting Escalations page. Presentational.

import { Card, FormField, Input } from "@/design-system/components/ui";
import type {
  CriteriaLane,
  ReunderwritingEscalationStatus,
} from "@/types/reunderwriting";

interface Props {
  status: ReunderwritingEscalationStatus | null;
  lane: CriteriaLane | null;
  from: string;
  to: string;
  onChange: (next: Partial<Record<string, string | null>>) => void;
}

const STATUSES: ReunderwritingEscalationStatus[] = ["Pending", "Approved", "Denied"];
const LANES: CriteriaLane[] = ["A1", "A2", "A3", "A4"];

export function ReunderwritingEscalationFilterSidebar({
  status,
  lane,
  from,
  to,
  onChange,
}: Props) {
  return (
    <Card className="p-space-4 flex flex-col gap-space-4" aria-label="Filters">
      <div role="group" aria-labelledby="ru-esc-status">
        <h2
          id="ru-esc-status"
          className="font-display text-label uppercase tracking-label text-onyx mb-space-2"
        >
          Status
        </h2>
        <div className="flex flex-col gap-space-1">
          {STATUSES.map((s) => (
            <label
              key={s}
              className="inline-flex items-center gap-space-2 text-body text-onyx cursor-pointer"
            >
              <input
                type="radio"
                name="ru-esc-status-radio"
                checked={status === s}
                onChange={() => onChange({ status: s })}
              />
              <span>{s}</span>
            </label>
          ))}
          <button
            type="button"
            className="text-caption text-gold underline self-start"
            onClick={() => onChange({ status: null })}
          >
            Any status
          </button>
        </div>
      </div>

      <div role="group" aria-labelledby="ru-esc-lane">
        <h2
          id="ru-esc-lane"
          className="font-display text-label uppercase tracking-label text-onyx mb-space-2"
        >
          Lane
        </h2>
        <div className="flex flex-col gap-space-1">
          {LANES.map((l) => (
            <label
              key={l}
              className="inline-flex items-center gap-space-2 text-body text-onyx cursor-pointer"
            >
              <input
                type="radio"
                name="ru-esc-lane-radio"
                checked={lane === l}
                onChange={() => onChange({ lane: l })}
              />
              <span>{l}</span>
            </label>
          ))}
          <button
            type="button"
            className="text-caption text-gold underline self-start"
            onClick={() => onChange({ lane: null })}
          >
            Any lane
          </button>
        </div>
      </div>

      <div>
        <h2 className="font-display text-label uppercase tracking-label text-onyx mb-space-2">
          Date range
        </h2>
        <div className="flex flex-col gap-space-2">
          <FormField htmlFor="ru-esc-from" label="From">
            <Input
              id="ru-esc-from"
              type="date"
              value={from}
              onChange={(e) => onChange({ from: e.target.value || null })}
            />
          </FormField>
          <FormField htmlFor="ru-esc-to" label="To">
            <Input
              id="ru-esc-to"
              type="date"
              value={to}
              onChange={(e) => onChange({ to: e.target.value || null })}
            />
          </FormField>
        </div>
      </div>
    </Card>
  );
}
